import { useDispatch } from 'react-redux';
import AdminViewFormSideBar from '../admin/adminViewForm/AdminViewFormSideBar';
import PreviewHeader from './PreviewHeader';
import { setSectionId } from '@/reducers/sectionIdSlice';
import { useGetSectionsDataQuery } from '@/services/userService/userServiceEndpoints';
import { useEffect, useState } from 'react';
import PreviewViewForm from './PreviewViewForm';
import Loader from '@/components/Loader/Loader';
import { setDistrictId } from '@/reducers/app-global-slice';
const PreviewDashboard = () => {
  const dispatch = useDispatch();

  const [selectDistrict, setSelectDistrict] = useState('');
  const [districtName, setDistrictName] = useState('');

  const {
    data: SectionItem,
    isLoading,
    isFetching,
    isSuccess,
  } = useGetSectionsDataQuery(
    {
      districtId: selectDistrict,
    },
    {
      skip: !selectDistrict,
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (isSuccess && SectionItem?.data?.section_responses?.length > 0) {
      const firstSection = SectionItem.data.section_responses[0];
      const firstSectionId = firstSection.section_id || firstSection.id || 'Instructions';

      dispatch(setSectionId(firstSectionId));
    }
  }, [isSuccess, SectionItem]);
  const handleSectionClick = (sectionObj: { section_id: string; section_name: string }): void => {
    if (sectionObj) {
      dispatch(setSectionId(sectionObj.section_id));
    }
  };

  useEffect(() => {
    dispatch(setDistrictId(selectDistrict));
  }, [selectDistrict]);
  return (
    <>
      {isLoading || isFetching ? (
        <div className="flex justify-center items-center h-full">
          <Loader color="primary" size="xl" />
        </div>
      ) : (
        <div className="flex flex-col gap-2 bg-red-50 h-full pr-2 overflow-hidden">
          <PreviewHeader
            setSelectDistrict={setSelectDistrict}
            selectDistrict={selectDistrict}
            setDistrictName={setDistrictName}
            factSheetName={SectionItem?.data?.fact_sheet_name || 'Plaintiff Fact Sheet'}
          />
          <div className="flex flex-col w-full h-full bg-ds-gray-gray-white overflow-hidden shadow-sm rounded-[8px] p-2">
            <div
              className={`flex flex-col lg:flex-row border border-ds-gray-100 rounded-md bg-ds-gray-gray-white h-[100%]`}
            >
              <div className="h-full border-r">
                <AdminViewFormSideBar
                  sections={SectionItem?.data?.section_responses}
                  onSectionClick={handleSectionClick}
                  isProgressBarShow={false}
                />
              </div>
              <div className="flex flex-col w-full lg:h-full bg-ds-gray-gray-white">
                <PreviewViewForm
                  selectDistrict={selectDistrict}
                  isSuccess={isSuccess}
                  sections={SectionItem?.data?.section_responses}
                  districtName={districtName}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PreviewDashboard;
